<template>
  <!-- 嵌入 iframe -->
  <iframe
    src="https://steamui.com/"
    frameborder="0"
    class="full-iframe"
  ></iframe>
</template>

<script>
export default {
  name: 'SteamDB',
};
</script>

<style scoped>
/* 让 iframe 全屏显示 */
.full-iframe {
  width: 100%;
  height: 100vh;
  border: none;
}
</style>